import { VideoInfo } from "./models/videoInfo";
import { GapVM } from "./models/gapVM";
import moment from "moment";
import { VideoPlayBackMode } from "../../Models/devices";

export function getTotalGapDurationOfAllGapsThatOccurBeforeGivenVideoTimestamp(
  videoInfo: VideoInfo,
  startDateTime: string,
  timestamp: number
) {
  try {
    if (!videoInfo) {
      throw new Error("Video data is not available.");
    }
    return videoInfo.gaps.reduce((acc, g) => {
      return getGapOccurrenceTimeOnVideoTimelineByGap(videoInfo, startDateTime, g) < timestamp
        ? acc + g.durationSeconds
        : acc;
    }, 0);
  } catch (error) {
    console.error(error);
    return 0;
  }
}

export function getGapOccurrenceTimeOnVideoTimelineByGap(
  videoInfo: VideoInfo,
  startDateTime: string,
  gap: GapVM
) {
  try {
    if (!videoInfo) {
      throw new Error("Video data is not available.");
    }
    const totalDurationOfGapsThatStartBeforeGivenStartTime = videoInfo.gaps.reduce((acc, g) => {
      return ISOtoSeconds(startDateTime, g.startTime) < ISOtoSeconds(startDateTime, gap.startTime)
        ? acc + g.durationSeconds
        : acc;
    }, 0);
    return (
      ISOtoSeconds(startDateTime, gap.startTime) - totalDurationOfGapsThatStartBeforeGivenStartTime
    );
  } catch (error) {
    console.error(error);
    return 0;
  }
}

export function ISOtoSeconds(startDateTime: string, timestamp: string) {
  // Convert timestamp to seconds elapsed in video
  const correctedTimestamp = timestamp.endsWith("Z") ? timestamp : `${timestamp}Z`;
  return moment(correctedTimestamp).diff(moment(startDateTime), "seconds");
}

export function addSecondsToDate(startDate: string, seconds: number) {
  const t = new Date(startDate);
  return new Date(t.getTime() + seconds * 1000);
}

export function getDateJson(date: Date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hour: date.getHours(),
    minute: date.getMinutes(),
    seconds: date.getSeconds(),
    milliseconds: date.getMilliseconds(),
  };
}

export function isSDLowPlaybackCamera(videoInfo: VideoInfo) {
  return videoInfo?.playbackMode === VideoPlayBackMode.SDLow;
}
